import { StackSharedProps } from "@certn/cascadia";
import { cssToken } from "@certn/cascadia/utils";
import { css, cx } from "@emotion/css";
import { LegacyRef } from "react";

import { useLayout } from "./Layout";
import { mq } from "../../components/utils";

interface Props extends StackSharedProps {
  /**
   * The class name to apply to the stack
   */
  elementRef?: LegacyRef<HTMLDivElement>;
  className?: string;
}

export function Stack(props: Props) {
  const { layoutValues } = useLayout();

  const { orientation = "vertical", gap, children } = props;

  return (
    <div
      ref={props.elementRef}
      className={cx(
        styles.stack,
        props.className,
        css(
          mq({
            rowGap: layoutValues.gapVertical.map(cssToken),
            columnGap: layoutValues.gapHorizontal.map(cssToken),
          })
        )
      )}
      style={{
        rowGap: orientation === "vertical" ? cssToken(gap) : undefined,
        alignItems: props.align,
        columnGap: orientation === "horizontal" ? cssToken(gap) : undefined,
      }}
      data-orientation={orientation}
      data-testid={props.testID}
    >
      {children}
    </div>
  );
}

const styles = {
  stack: css({
    display: "flex",
    "&[data-orientation=vertical]": {
      flexDirection: "column",
    },
    "&[data-orientation=horizontal]": {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
    },
  }),
};
